/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppWrapper from "../components/layout/Styles/index";
import Routes from "../routes";
import "./App.css";
import "./custom.scss";
// import "./darkThemeStyle.css";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { setAuth, setAuthLoader } from "../redux/actions/Auth";
import {
  setAuthParams,
  setGlobalBrands,
  setGlobalDuration,
  setGlobalSingleBrands,
  setPersistAuthParams,
  updateAuthParamsScreenId,
} from "../redux/actions/AuthParams";
//import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
//import { reactPlugin } from "../appInsights";
import { onDashboardReset } from "../redux/actions/dashboard/Tab1";
import {
  checkBackgroundIsDark,
  getBrands,
  getSelectedCompBrand,
  getWindowLocationPath,
  setCookie,
} from "../redux/constants";
import { setTemporaryWords } from "../redux/actions/Attribute";
import { setTemplateDetails } from "../redux/actions/section/section";
import { datadogRum } from "@datadog/browser-rum";
import config1 from "../config";
const LandingPage = React.lazy(() =>
  import("../components/layout/LandingPage")
);
if (config1?.config1?.app_id === "6") {
  datadogRum.init({
    applicationId: config1?.config1?.datadog_application_id,
    clientToken: config1?.config1?.datadog_client_token,
    service: config1?.config1?.datadog_service_name,
    env: config1?.config1?.datadog_env,
    site: "us5.datadoghq.com",
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    premiumSampleRate: 100,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
  });
  datadogRum?.startSessionReplayRecording();
}
const App = () => {
  const [flag, setFlag] = useState(false); //flag to show unauthorized user
  //Redux state
  const auth = useSelector((state) => state.Authentication.auth);
  const authLoader = useSelector((state) => state.Authentication.authLoader);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const authParamsPersist = useSelector(
    (state) => state?.AuthParams?.authParams
  );
  const competitorBrands = useSelector(
    (state) => state.WidgetAPI.competitorBrands?.data?.result
  );
  const brands = useSelector(
    (state) => state?.ApiCall?.brands?.data?.result?.brands
  );
  const PersonalizationSettingState = useSelector(
    (state) => state?.PersonalizationSetting
  );
  // store info about command center screen
  const screen = useSelector((state) => state?.Screens?.screen);
  const templateObj = useSelector(
    (state) => state?.scheduleReport?.templateObj
  );
  const dispatch = useDispatch(); //To use useDispatch hook
  var urlParams; // url encrypted parameters

  //Function to get url params from URL and set it to urlParams variable
  (window.onpopstate = function () {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      query = window.location.search.substring(1);

    urlParams = {};
    while ((match = search.exec(query)))
      urlParams[decode(match[1])] = decode(match[2]);
  })();

  //function to get cookie
  const getCookie = (cname) => {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };

  const handleFlag = async () => {
    let ptoken = getCookie("ptoken");
    let user_id = getCookie("userid");

    if (
      (urlParams?.temp_token && urlParams?.userid) ||
      (ptoken && user_id) ||
      (urlParams?.ptoken && urlParams?.userid) ||
      urlParams?.share_id ||
      urlParams?.pdf_id
    ) {
      setFlag(false);
    } else {
      setFlag(true);
    }
  };

  const formatBrandGroup = (value) => {
    let data = [];

    value?.split(",")?.map((el) => {
      data.push({ group: true, brand_group_name: el, brand_friendly_name: el });
    });
    return data;
  };

  const formatBrandId = (value, compBrands) => {
    let brand_arr = value?.split(",")?.map((el) => {
      return { brand_id: parseInt(el) };
    });
    if (!compBrands) {
      let brands1 = getBrands([], brand_arr, brands, []);
      return brands1?.columns;
    } else {
      return null;
    }
  };
  const formatCompBrand = (value, brand_ids) => {
    let comp_brand_arr = value?.split(",")?.map((el) => {
      return { brand_id: parseInt(el) };
    });
    let comp_brands = getSelectedCompBrand(
      competitorBrands,
      [{ brand_id: brand_ids?.split(",")?.[0] }],
      comp_brand_arr
    );
    return comp_brands;
  };

  useEffect(() => {
    let ptoken = getCookie("ptoken");
    let user_id = getCookie("userid");
    if (urlParams?.temp_token && urlParams?.userid) {
      window.localStorage.clear();
      dispatch(setAuth(urlParams?.temp_token, urlParams?.userid));
      dispatch(setAuthLoader(true));
      dispatch(setTemporaryWords({}));
    }
    if (urlParams?.tagid) {
      let params = {
        ptoken: ptoken ? ptoken : urlParams?.ptoken,
        userid: user_id && parseInt(user_id),
        tag_id: urlParams?.tagid,
        theme_type: urlParams?.theme_type,
      };
      dispatch(setAuthParams(false, params));
    } else if (urlParams?.ppt && !urlParams?.template_id && ptoken && user_id) {
      let params = {
        ptoken: ptoken,
        userid: user_id && parseInt(user_id),
        ppt: urlParams?.ppt,
        ai: urlParams?.ai,
        theme_id: urlParams?.theme_id,
        ppt_type: urlParams?.ppt_type,
        quickFilterName: urlParams?.quickFilterName,
        adssetValue: urlParams?.adssetValue,
        adsValue: urlParams?.adsValue,
        start_date: urlParams?.startDate,
        end_date: urlParams?.endDate,
        brandGroup: urlParams?.brandGroup
          ? formatBrandGroup(urlParams?.brandGroup)
          : null,
        brandId: urlParams?.brandId
          ? formatBrandId(urlParams?.brandId, urlParams?.compBrands)
          : null,
        compBrands: urlParams?.compBrands
          ? formatCompBrand(urlParams?.compBrands, urlParams?.brandId)
          : null,
        filters: urlParams?.filters ? JSON.parse(urlParams?.filters) : null,
        profile_filters: urlParams?.profile_filters
          ? JSON.parse(urlParams?.profile_filters)
          : null,
      };
      dispatch(setAuthParams(false, params));
    } else if (urlParams?.ppt && urlParams?.template_id && ptoken && user_id) {
      let params = {
        ptoken: ptoken,
        userid: user_id && parseInt(user_id),
        template_id: urlParams?.template_id,
        ai: urlParams?.ai,
        ppt: urlParams?.ppt,
        theme_id: urlParams?.theme_id,
        ppt_type: urlParams?.ppt_type,
        quickFilterName: urlParams?.quickFilterName,
        quickFilterValue: urlParams?.quickFilterValue,
        adssetValue: urlParams?.adssetValue,
        adsValue: urlParams?.adsValue,
        start_date: urlParams?.startDate,
        end_date: urlParams?.endDate,
        brandGroup: urlParams?.brandGroup
          ? formatBrandGroup(urlParams?.brandGroup)
          : null,
        brandId: urlParams?.brandId
          ? formatBrandId(urlParams?.brandId, urlParams?.compBrands)
          : null,
        compBrands: urlParams?.compBrands
          ? formatCompBrand(urlParams?.compBrands, urlParams?.brandId)
          : null,
        filters: urlParams?.filters ? JSON.parse(urlParams?.filters) : null,
        profile_filters: urlParams?.profile_filters
          ? JSON.parse(urlParams?.profile_filters)
          : null,
      };

      dispatch(setAuthParams(false, params));
    } else if (
      urlParams?.ptoken &&
      urlParams?.userid &&
      !authParams &&
      getWindowLocationPath()?.toLowerCase() === "commandCenter"?.toLowerCase()
    ) {
      //iframe integrated in Angular tool
      let oldPtoken = getCookie("ptoken");
      if (oldPtoken) {
        if (oldPtoken !== atob(urlParams?.ptoken)) {
          dispatch(setGlobalDuration(null));
          dispatch(setGlobalBrands(null));
          dispatch(setGlobalSingleBrands(null));
          dispatch(onDashboardReset());
          dispatch(setTemporaryWords({}));
          dispatch(setTemplateDetails(null));
          window.localStorage.clear();
        }
      }
      let params = {
        ptoken: atob(urlParams?.ptoken),
        userid: parseInt(urlParams?.userid),
        template_id: urlParams?.template_id,
        v3: urlParams?.v3,
        brandID: urlParams?.brandID,
        quickFilterName: urlParams?.quickFilterName,
        quickFilterValue: urlParams?.quickFilterValue,
        startDate: urlParams?.startDate,
        endDate: urlParams?.endDate,
        ppt: urlParams?.ppt,
        theme_type: authParams?.theme_type
          ? authParams?.theme_type
          : urlParams?.theme_type,
        ppt_type: urlParams?.ppt_type,
        screen_id: urlParams?.screen_id,
        ng_token: urlParams?.ng_token,
      };
      let persistParam = {
        ptoken: atob(urlParams?.ptoken),
        userid: parseInt(urlParams?.userid),
        v3: urlParams?.v3,
        logical_brand_group: urlParams?.logical_brand_group
          ? urlParams?.logical_brand_group
          : null,
      };
      setCookie("ptoken", atob(urlParams?.ptoken));
      setCookie("userid", parseInt(urlParams?.userid));
      dispatch(setPersistAuthParams(false, persistParam));
      dispatch(setAuthParams(false, params));
      localStorage.setItem("ng_token", urlParams?.ng_token);
    } else if (urlParams?.ptoken && urlParams?.userid && !authParams) {
      //iframe integrated in Angular tool
      let oldPtoken = getCookie("ptoken");
      if (oldPtoken) {
        if (oldPtoken !== urlParams?.ptoken) {
          dispatch(setGlobalDuration(null));
          dispatch(setGlobalBrands(null));
          dispatch(setGlobalSingleBrands(null));
          dispatch(onDashboardReset());
          dispatch(setTemporaryWords({}));

          dispatch(setTemplateDetails(null));

          window.localStorage.clear();
        }
      }
      let params = {
        ptoken: urlParams?.ptoken,
        userid: parseInt(urlParams?.userid),
        template_id: urlParams?.template_id,
        v3: urlParams?.v3,
        brandID: urlParams?.brandID,
        quickFilterName: urlParams?.quickFilterName,
        quickFilterValue: urlParams?.quickFilterValue,
        startDate: urlParams?.startDate,
        endDate: urlParams?.endDate,
        ppt: urlParams?.ppt,
        theme_type: authParams?.theme_type
          ? authParams?.theme_type
          : urlParams?.theme_type,
        ppt_type: urlParams?.ppt_type,
        redirectToDIY: urlParams?.redirectToDIY,
        screen_id: urlParams?.screen_id,
        ng_token: urlParams?.ng_token,
      };
      setCookie("ptoken", urlParams?.ptoken);
      setCookie("userid", parseInt(urlParams?.userid));
      dispatch(setAuthParams(false, params));
      localStorage.setItem("ng_token", urlParams?.ng_token);
    } else if (
      urlParams?.filterScreen &&
      urlParams?.screen_id &&
      ptoken &&
      user_id &&
      authParamsPersist &&
      getWindowLocationPath()?.toLowerCase() === "commandCenter"?.toLowerCase()
    ) {
      let params = {
        ...{ ...authParamsPersist },
        ptoken: ptoken,
        userid: user_id && parseInt(user_id),
        filterScreen: urlParams?.filterScreen,
        screen_id: urlParams?.screen_id,
        theme_id: urlParams?.theme_id,
        start_date: urlParams?.startDate,
        end_date: urlParams?.endDate,
        brandGroup: urlParams?.brandGroup
          ? formatBrandGroup(urlParams?.brandGroup)
          : null,
        brandId: urlParams?.brandId
          ? formatBrandId(urlParams?.brandId, urlParams?.compBrands)
          : null,
        compBrands: urlParams?.compBrands
          ? formatCompBrand(urlParams?.compBrands, urlParams?.brandId)
          : null,
        filters: urlParams?.filters ? JSON.parse(urlParams?.filters) : null,
      };
      let persistParam = {
        ...{ ...authParamsPersist },
        ptoken: ptoken,
        userid: user_id && parseInt(user_id),
      };
      dispatch(setPersistAuthParams(false, persistParam));
      dispatch(setAuthParams(false, params));
    } else if (
      authParamsPersist &&
      getWindowLocationPath()?.toLowerCase() === "commandCenter"?.toLowerCase()
    ) {
      dispatch(
        updateAuthParamsScreenId(authParamsPersist, {
          isPersistStore: true,
          // theme_type: "1",
        })
      );
    } else if (
      ((ptoken && user_id && !auth) ||
        (auth?.data?.result?.user_id && auth?.data?.result?.ptoken)) &&
      !authParams &&
      getWindowLocationPath()?.toLowerCase() !== "commandCenter"?.toLowerCase()
    ) {
      let params = {
        ptoken: ptoken ? ptoken : auth?.data?.result?.ptoken,
        userid: user_id ? parseInt(user_id) : auth?.data?.result?.user_id,
        theme_type: authParams?.theme_type
          ? authParams?.theme_type
          : urlParams?.theme_type,
      };
      dispatch(setAuthParams(false, params));
    }
    if (config1?.config1?.app_id === "6") {
      if (
        (auth?.data?.result?.ptoken && auth?.data?.result?.user_id) ||
        (ptoken && user_id)
      ) {
        datadogRum?.setUser({
          name: auth?.data?.result?.user_id
            ? auth?.data?.result?.user_id
            : user_id,
          id: auth?.data?.result?.user_id
            ? auth?.data?.result?.user_id
            : user_id,
          // email: auth?.data?.result?.user_id ? auth?.data?.result?.user_id : user_id,
          // team: auth?.data?.result?.user_id ? auth?.data?.result?.user_id : user_id
        });
        let user = datadogRum?.getUser();
      }
    }

    handleFlag();
  }, [auth, competitorBrands, brands]);

  useEffect(() => {
    auth?.data?.status === "successful" && dispatch(setAuthLoader(false));
    if (auth?.data?.status === "error") {
      dispatch(setAuthLoader(false));
      if (auth?.data?.error_code === 10) window.location.href = "/activate";
    }
  }, [auth]);
  useEffect(() => {
    if (
      getWindowLocationPath()?.toLowerCase() ===
        "CommandCenter"?.toLowerCase() &&
      screen?.theme &&
      !templateObj?.isPdfPreview
    ) {
      document.documentElement.setAttribute("data-theme", "customTheme");
    } else if (
      (authParams?.theme_type === "1" ||
        getWindowLocationPath()?.toLowerCase() ===
          "CommandCenter"?.toLowerCase()) &&
      !templateObj?.isPdfPreview
    ) {
      document.documentElement.setAttribute("data-theme", "dark");
    } else {
      document.documentElement.setAttribute("data-theme", "light");
    }
  }, [authParams, screen?.theme, templateObj?.isPdfPreview]);
  useEffect(() => {
    // console.log("\n\n ******************* App.js *********\n\n");
    // console.log(
    //   authParams,
    //   "templateObj?.isPdfPreview : ",
    //   templateObj?.isPdfPreview
    // );
    if (templateObj?.isPdfPreview && authParams?.theme_type === "1") {
      dispatch(
        updateAuthParamsScreenId(authParams, {
          theme_type: "0",
          previous_theme_type: authParams?.theme_type,
        })
      );
    } else if (!templateObj?.isPdfPreview && authParams?.previous_theme_type) {
      dispatch(
        updateAuthParamsScreenId(authParams, {
          theme_type: authParams?.previous_theme_type,
          reset_previous_theme_type: true,
        })
      );
    }
    // console.log("\n\n ******************* App.js End *********\n\n");
  }, [templateObj?.isPdfPreview]);
  useEffect(() => {
    // console.log("\n\n ******************* App.js *********\n\n");
    // console.log(
    //   "screen?.screen_id : ",
    //   screen?.screen_id,
    //   authParams,
    //   screen?.theme
    // );
    // debugger;
    if (screen?.screen_id && authParams?.screen_id) {
      if (
        getWindowLocationPath()?.toLowerCase() ===
          "CommandCenter"?.toLowerCase() &&
        screen?.theme
      ) {
        let isDarkScreenBackground = true;
        if (PersonalizationSettingState?.isPersonalizationPreviewOpen) {
          const selectedPalette = Array.isArray(
            PersonalizationSettingState?.paletteList
          )
            ? PersonalizationSettingState?.paletteList?.find(
                (palette) => palette?.isSelected
              )
            : PersonalizationSettingState?.paletteList?.[0]
            ? PersonalizationSettingState?.paletteList?.[0]
            : null;
          isDarkScreenBackground = checkBackgroundIsDark(
            selectedPalette?.ScreenBackgroundColor
          );
        } else {
          let themeDataObj = { ...screen?.theme };
          const selectedPalette = Array.isArray(
            themeDataObj?.theme_json?.paletteList
          )
            ? themeDataObj?.theme_json?.paletteList?.find(
                (palette) => palette?.isSelected
              )
            : themeDataObj?.theme_json?.paletteList?.[0]
            ? themeDataObj?.theme_json?.paletteList?.[0]
            : null;
          isDarkScreenBackground = checkBackgroundIsDark(
            selectedPalette?.ScreenBackgroundColor
          );
        }

        // console.log(
        //   "\n\n First if ******************* App.js *********\n\n",
        //   "isDarkScreenBackground : ",
        //   isDarkScreenBackground
        // );
        if (isDarkScreenBackground && authParams?.theme_type !== "1") {
          // console.log(
          //   "\n\n first inner if ******************* App.js *********\n\n"
          // );
          dispatch(
            updateAuthParamsScreenId(authParams, {
              theme_type: "1",
            })
          );
        } else if (!isDarkScreenBackground && authParams?.theme_type !== "0") {
          // console.log(
          //   "\n\n first inner else ******************* App.js *********\n\n"
          // );
          dispatch(
            updateAuthParamsScreenId(authParams, {
              theme_type: "0",
            })
          );
        }
      } else if (
        getWindowLocationPath()?.toLowerCase() ===
          "CommandCenter"?.toLowerCase() &&
        authParams?.theme_type !== "1"
      ) {
        // console.log("\n\n first else ******************* App.js *********\n\n");
        dispatch(
          updateAuthParamsScreenId(authParams, {
            theme_type: "1",
          })
        );
      }
    }
    // console.log("\n\n ******************* App.js End *********\n\n");
  }, [screen?.screen_id, screen?.theme, PersonalizationSettingState?.themeId]);
  // let darkTheme = document.body.getAttribute("data-theme") === "dark";
  // console.log(
  //   "authParams : ",
  //   authParams,
  //   "PersonalizationSettingState : ",
  //   PersonalizationSettingState
  // );
  if (flag && window.location.pathname === "/explore")
    return (
      <>
        <Suspense
          fallback={
            <div
              className="d-flex align-items-center"
              style={{
                justifyContent: "space-evenly",
                height: "calc(100vh - 4rem)",
              }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          }
        >
          <LandingPage />
        </Suspense>
      </>
    );
  else if (authLoader) {
    return (
      <>
        <div
          className={`loader mt-5 ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </>
    );
  } else {
    return (
      // <AppInsightsContext.Provider value={reactPlugin}>
      <Router>
        <AppWrapper
        // className={
        //   authParams?.theme_type === "1" ||
        //   getWindowLocationPath()?.toLowerCase() ===
        //     "CommandCenter"?.toLowerCase()
        //     ? "darkTheme mainDarkTheme bodyTheme"
        //     : "lightTheme bodyThemeLight"
        // }
        // data-theme={
        //   authParams?.theme_type === "1" ||
        //   getWindowLocationPath()?.toLowerCase() ===
        //     "CommandCenter"?.toLowerCase()
        //     ? "dark"
        //     : "light"
        // }
        >
          <Routes />
        </AppWrapper>
      </Router>
      // </AppInsightsContext.Provider>
    );
  }
};

export default App;
